import { render, staticRenderFns } from "./VFatherProTests.vue?vue&type=template&id=270de9d7"
import script from "./VFatherProTests.vue?vue&type=script&lang=js"
export * from "./VFatherProTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports